export default "__VITE_ASSET__CaiSjEqs__"